<div class="vtr-header-main">
	<img
		class="vtr-header-main-img"
		src="assets/images/headerImage-le.png"
		alt="header-background"
		attr.aria-label="header-background"
	/>
	<div class="vtr-header-main-inner">
		<a  class="back"
			(click)="goBack($event)"
			[ngClass]="{'invisible': hideBack}"
			[hidden]="hideBack"
			id="{{backId}}"
			tabindex="{{ hideBack ? -1 : 0 }}"
			*ngIf="back && back.length > 0"
			role="link"
			[attr.aria-label]="back"
			href="#">
			<fa-icon [icon]="faChevronLeft" [attr.aria-label]="back" role="text"></fa-icon>
			<span class="hyperlink-button back-button">{{back}}</span>
		</a>
		<h1
			class="title"
			id="{{textId}}-header-title"
			[attr.aria-label]="title"
			role="heading"
			aria-level="1"
			[hidden]="hideTitle || title === ''"
			[innerHTML]="title"
		>
		</h1>
		<div class="welcomeText-placeholder" [hidden]="!(hideTitle || title === '')"></div>
		<ng-content></ng-content>
		<div *ngIf="forwardLink" class="forward-link">
			<a routerLink="/{{forwardLink.path}}" id="header-main-forward-link-path">
				<span
					role="text"
					attr.aria-label="{{forwardLink.label}}"
					class="forward-link-label"
				>
					{{forwardLink.label}}
				</span>
				<fa-icon
					[icon]="['fas', 'arrow-right']"
					class="forward-link-icon"
					role="img"
					alt="forward-link"
					aria-label="forward link"
					class="forward-link-icon"
				>
				</fa-icon>
			</a>
		</div>
		<div class="menu" *ngIf="menuItems">
			<vtr-menu-header [menuItems]="menuItems"></vtr-menu-header>
		</div>
	</div>
</div>
